import { Modal as AntdModal, type ModalProps as AntdModalProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { isKeyOfObject } from '@/utils/functions/helpers/isKeyOfObject'

const modalSizes = {
  large: '66.66%',
  middle: '50%',
  small: '33.33%',
  extraSmall: '25%',
}

export interface ModalProps extends AntdModalProps {
  width?: keyof typeof modalSizes | AntdModalProps['width']
}

export function Modal({
  cancelText,
  okText,
  width = 'middle',
  centered = true,
  bodyStyle,
  ...props
}: ModalProps) {
  const { t } = useTranslation()

  const defaultOkText = t('components.modals.defaultButtons.save')
  const defaultCancelText = t('components.modals.defaultButtons.cancel')

  return (
    <AntdModal
      width={isKeyOfObject(width, modalSizes) ? modalSizes[width] : width}
      cancelText={cancelText ?? defaultCancelText}
      okText={okText ?? defaultOkText}
      centered={centered}
      bodyStyle={{
        maxHeight: '60vh',
        overflowY: 'auto',
        ...bodyStyle,
      }}
      {...props}
    />
  )
}
